import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './faams-application.css';
import logo from '../images/FAAMS__FAAMS_Goldlogo.png'
import axiosInstance from "../utils/axiosInstance";
import { FaFilePdf } from "react-icons/fa";
import { ArrowLeft, Trash2, Upload, X, Plus} from 'lucide-react';
import axios from 'axios';

function Faams_Application({user, setUser}) {
    const API_URL = process.env.REACT_APP_ENV;
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        gender:'',
        gradYear:'',
        race:'',
        ethnicity:'',
        address:'',
        address2:'',
        state:'',
        city:'',
        zip:'',
        dobMonth:'',
        dobDay:'',
        dobYear:'',
        essay_question1:'',
        essay_question2:'',
        essay_question3:'',
        essay_question4:'',
        application_pdf_key:'',
        photo_id_key:'',
        misc_file_key:[],
        recommender_1_first_name:'',
        recommender_1_last_name:'',
        recommender_1_email:'',
        recommender_2_first_name:'',
        recommender_2_last_name:'',
        recommender_2_email:'',
        recommender_3_first_name:'',
        recommender_3_last_name:'',
        recommender_3_email:''
    }) 
    const { application_id, step } = useParams();

    const [existingMiscFiles, setExistingMiscFiles] = useState([]);

    useEffect(() => {
    const fetchApplicationDetails = async () => {
        console.log("Fetching Application Details")
        try {
            const response = await axiosInstance.get(`${API_URL}/faams-scholarship/${application_id}`);
            const applicationDetails = response.data;
            setFormData(prev => ({
                ...prev,
                firstName:applicationDetails?.first_name || '',
                lastName:applicationDetails?.last_name || '',
                email: applicationDetails?.email_address || '',
                phone: applicationDetails?.phone_number || '',
                gender: applicationDetails?.gender || '',
                gradYear: applicationDetails?.graduation_year || '',
                race: applicationDetails?.racial_identity || '',
                ethnicity: applicationDetails?.hispanic_origin || '',
                address: applicationDetails?.address || '',
                address2: applicationDetails?.address2 || '',
                state: applicationDetails?.state || '',
                city: applicationDetails?.city || '',
                zip: applicationDetails?.zip || '',
                dobMonth: applicationDetails?.dob?.split("-")[1] || '',
                dobDay: applicationDetails?.dob?.split("-")[2] || '',
                dobYear: applicationDetails?.dob?.split("-")[0] || '',
                essay_question1:applicationDetails?.essay_question1 || '',
                essay_question2:applicationDetails?.essay_question2 || '',
                essay_question3:applicationDetails?.essay_question3 || '',
                essay_question4:applicationDetails?.essay_question4 || '',
                application_pdf_key:applicationDetails?.application_pdf_key || '',
                photo_id_key:applicationDetails?.photo_id_key || '',
                misc_file_key:applicationDetails?.misc_file_key || []

                
            }));
                } catch (err) {
                    console.error("Failed to fetch application details", err);
                }
        };

        fetchApplicationDetails();

    }, [application_id, API_URL]);
    useEffect(() => {
    const fetchRecommendationDetails = async () => {
        console.log("Fetching Recommendation Details")
        try {
            const response = await axiosInstance.get(`${API_URL}/faams-scholarship/${application_id}/recommendation`);
            const recommendationDetails = response.data;
            setFormData(prev => ({
                ...prev,
                recommender_1_first_name:recommendationDetails?.[0]?.first_name ||'',
                recommender_1_last_name:recommendationDetails?.[0]?.last_name ||'',
                recommender_1_email:recommendationDetails?.[0]?.email_address ||'',
                recommender_2_first_name:recommendationDetails?.[1]?.first_name ||'',
                recommender_2_last_name:recommendationDetails?.[1]?.last_name ||'',
                recommender_2_email:recommendationDetails?.[1]?.email_address ||'',
                recommender_3_first_name:recommendationDetails?.[2]?.first_name ||'',
                recommender_3_last_name:recommendationDetails?.[2]?.last_name ||'',
                recommender_3_email:recommendationDetails?.[2]?.email_address ||'',
            }));
                } catch (err) {
                    console.error("Failed to fetch application details", err);
                }
        };

        fetchRecommendationDetails();

    }, [application_id, API_URL]);

    const currentStep =
        Number(step) || 1;
    
        console.log(`Current Step: ${currentStep}`)

  return (
    <div>

      {currentStep === 1 && (
        <Basic_Information user={user}
        setUser={setUser} application_id={application_id} currentStep={currentStep} formData={formData}
    setFormData={setFormData}/>
      )}

      {currentStep === 2 && (
        <Essay_Questions1  application_id={application_id} currentStep={currentStep} formData={formData}
    setFormData={setFormData}/>
      )}

      {currentStep === 3 && (
        <Essay_Questions2  application_id={application_id} currentStep={currentStep} formData={formData}
    setFormData={setFormData}/>
      )}

      {currentStep === 4 && (
        <PDF application_id={application_id} currentStep={currentStep} formData={formData} setFormData={setFormData}/>
      )}

      {currentStep === 5 && (
        <LOR application_id={application_id} currentStep={currentStep} formData={formData} setFormData={setFormData}/>
      )}

      {currentStep === 6 && (
        <Misc application_id={application_id} currentStep={currentStep} formData={formData} setFormData={setFormData} existingMiscFiles={existingMiscFiles} setExistingMiscFiles={setExistingMiscFiles}/>
      )}

      {currentStep === 7 && (
        <ReviewSubmit application_id={application_id} formData={formData} setFormData={setFormData}/>
      )}

    </div>
  );
}

function Basic_Information({user, setUser, currentStep, application_id, formData, setFormData}) {
    console.log("Basic_Information render");
    const API_URL = process.env.REACT_APP_ENV;
    const navigate = useNavigate();  

    const formatPhone = (value) => {
        let digits = value.replace(/\D/g, "").slice(0, 10);
        if (digits.length == 10){
            digits = `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6,10)}`;
        } else if (digits.length == 7){
            digits = `${digits.slice(0,3)}-${digits.slice(3,7)}`;
        }
        return digits
    };
    const token =
            localStorage.getItem('token');

    useEffect(() => {
    const fetchUser = async () => {
        if (!token) {
            navigate('/login');
            return;
        }

        try {
                    const response = await axiosInstance.get(`${API_URL}/me`);
                    const updatedUser = response.data;
    
                    setFormData(prev => ({
                        ...prev,
                        firstName:formData?.firstName || updatedUser.first_name || '',
                        lastName:formData?.lastName || updatedUser.last_name || '',
                        email: formData?.email || updatedUser.email || '',
                        phone: formData?.phone || updatedUser.phone || '',
                        gender: formData?.gender || updatedUser.gender || ''
                        // gradYear:formData?.gradYear || '',
                        // race:formData?.race || '',
                        // ethnicity:formData?.ethnicity || '',
                        // address:formData?.address || '',
                        // address2:formData?.address2 || '',
                        // state:formData?.state || '',
                        // city:formData?.city || '',
                        // zip:formData?.zip || '',
                        // dobMonth:formData?.dobMonth || '',
                        // dobDay:formData?.dobDay || '',
                        // dobYear:formData?.dobYear || ''
                    }));
                } catch (err) {
                    console.error("Failed to fetch user", err);
                }
    };

    fetchUser();

}, [navigate, setUser]);

    const [error, setError] = useState(''); // State for displaying errors
    const [loading, setLoading] = useState(false); // State for showing loading status
    const handleChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;
        if (name === "phone") {
            newValue = formatPhone(value);
        }
        setFormData(prev => ({ 
            ...prev,
            ...formData, 
            [name]: newValue 
        }));
    };

    const handleBack = (e) => {
        e.preventDefault();
        navigate(`/faams-scholarship`);
    }

     const handleSubmit = async (e) => {
        e.preventDefault();
        // Clear previous error
        setError('');
        setLoading(true)
        const dob = `${String(formData.dobYear).padStart(4, "0")}-${String(formData.dobMonth).padStart(2, "0")}-${String(formData.dobDay).padStart(2, "0")}`;
        // Prepare the data to send to the backend
        const userData = {
            first_name: formData.firstName,
            last_name: formData.lastName,
            email_address: formData.email,
            phone_number: formData.phone,
            gender: formData.gender,
            graduation_year: formData.gradYear,
            racial_identity: formData.race,
            hispanic_origin: formData.ethnicity,
            dob: dob,
            address: formData.address,
            address2: formData.address2,
            city: formData.city,
            state: formData.state,
            zip: formData.zip
        };
        try {
            const response = await axiosInstance.patch(
                `${API_URL}/faams-scholarship/${application_id}`, userData,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            setFormData(prev => ({
            ...prev,
            ...userData
            }));
            navigate(`/faams-application/${application_id}/${currentStep += 1}`);

            console.log("Application Saved");
        } catch (error) {
            console.error("Error saving application:", error);
            alert("Failed to save changes.");
            setLoading(false)
        }
    }
    const states = [
    "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA",
    "HI","ID","IL","IN","IA","KS","KY","LA","ME","MD",
    "MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ",
    "NM","NY","NC","ND","OH","OK","OR","PA","RI","SC",
    "SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"
    ];

    return (
        <div className='faams-application-bg'>
           <div className = 'application-form-box'>
                <form onSubmit={handleSubmit}>
                <div className="faams-app-top-row">
                    <div className='logo-div'>
                        <ArrowLeft className='back-btn' color={"black"} size={40} onClick={handleBack}/>
                        <img src={logo} alt="faams-row-logo" />
                    </div>
                    <h1>FAAMS Scholarship</h1>
                    <p>Personal Information</p>
                </div>
                    <div className='application-form-row two-col'>
                        <div className = 'form-group'>
                            <label for="firstName">First Name</label>
                            <input 
                                type="text"
                                name="firstName"
                                placeholder="First Name"
                                value={formData.firstName}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className='form-group'>
                            <label for="lastName">Last Name</label>
                            <input 
                                type="text"
                                name="lastName"
                                placeholder="Last Name"
                                value={formData.lastName}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    <div className='application-form-row'>
                        <div className='form-group'>
                            <label for="dobMonth">Date of Birth</label>
                            <div className='dob-row'>
                                <select name="dobMonth" value={formData.dobMonth} onChange={handleChange}>
                                    <option value="" disabled>Month</option>
                                    <option value="1">January</option>
                                    <option value="2">February</option>
                                    <option value="3">March</option>
                                    <option value="4">April</option>
                                    <option value="5">May</option>
                                    <option value="6">June</option>
                                    <option value="7">July</option>
                                    <option value="8">August</option>
                                    <option value="9">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </select>
                                <input 
                                    type="text"
                                    name="dobDay"
                                    placeholder="Day"
                                    value={formData.dobDay}
                                    onChange={handleChange}
                                    minLength={1}
                                    maxLength={2}
                                    pattern="[0-9]{1,2}"
                                    inputMode="numeric"
                                    required
                                />
                                <input 
                                    type="text"
                                    name="dobYear"
                                    placeholder="Year"
                                    value={formData.dobYear}
                                    onChange={handleChange}
                                    minLength={4}
                                    maxLength={4}
                                    pattern="[0-9]{4}"
                                    inputMode="numeric"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    <div className='application-form-row three-col'>
                        <div className='form-group'>
                            <label for="gender">Gender</label>
                            <select
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                required
                            >
                                <option value="" disabled>Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        <div className='form-group'>
                            <label for="race">Racial Identity</label>
                            <select
                                name="race"
                                value={formData.race}
                                onChange={handleChange}
                                required
                            >
                                <option value="" disabled>Select</option>
                                <option value="Black/African-American">Black/African-American</option>
                                <option value="White">White</option>
                                <option value="Asian">Asian</option>
                                <option value="American-Indian">American Indian</option>
                                <option value="Pacific-Islander">Native Hawaiian or Other Pacific Islander</option>
                                <option value="Did not answer">Prefer not to answer</option>
                            </select>
                        </div>
                        <div className='form-group'>
                            <label for="gender">Are you of Hispanic, Latino, or Spanish origin?</label>
                            <select
                                name="ethnicity"
                                value={formData.ethnicity}
                                onChange={handleChange}
                                required
                            >
                                <option value="" disabled>Select</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                                <option value="Did not answer">Prefer not to answer</option>
                            </select>
                        </div>
                    </div>
                    <div className='application-form-row three-col'>
                        <div className='form-group'>
                            <label for="email">Email Address</label>
                            <input 
                                type="text"
                                name="email"
                                placeholder="Email Address"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className='form-group'>
                            <label for="phone">Phone Number</label>
                            <input 
                                type="tel"
                                name="phone"
                                placeholder="Phone Number"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className='form-group'>
                            <label for="gradYear">Anticipated Medical School Graduation Year</label>
                            <input 
                                type="text"
                                name="gradYear"
                                placeholder="Graduation Year"
                                value={formData.gradYear}
                                onChange={handleChange}
                                minLength={4}
                                maxLength={4}
                                pattern="[0-9]{4}"
                                inputMode="numeric"
                                required
                            />
                        </div>
                    </div>
                    <div className='application-form-row'>
                        <div className ='form-group'>
                            <label for="address">Address</label>
                            <div className = 'address-row'>
                                <input 
                                    type="text"
                                    name="address"
                                    placeholder="Street Address"
                                    value={formData.address}
                                    onChange={handleChange}
                                    required
                                />
                                <input 
                                    type="text"
                                    name="address2"
                                    placeholder="Suite/Apt"
                                    value={formData.address2}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                     <div className='application-form-row three-col'>
                        <div className = 'form-group'>
                            <input 
                                type="text"
                                name="city"
                                placeholder="City"
                                value={formData.city}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className='form-group'>
                            <select
                                name="state"
                                value={formData.state}
                                onChange={handleChange}
                            >
                                <option value="" disabled>State</option>
                                {states.map(state => (
                                    <option key={state} value={state}>
                                        {state}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className = 'form-group'>
                            <input
                                type="text"
                                name="zip"
                                placeholder="Zip Code"
                                value={formData.zip}
                                onChange={handleChange}
                                minLength={5}
                                maxLength={10}
                                pattern="[0-9]{5}(-[0-9]{4})?"
                                inputMode="numeric"
                                required
                            />
                        </div>
                    </div>
                    <div className='application-form-row'>
                     {error && <p style={{ color: 'red' }}>{error}</p>} 
                    </div>
                    <div className='application-form-row'>
                        <div className='button-row'>
                            <button type='submit' disabled={loading}>
                                {loading ? 'Loading...' : 'Continue'}
                            </button>
                        </div>
                    </div>
                </form>
           </div>
        </div>
    )
};

function Essay_Questions1({currentStep, application_id, formData, setFormData}){
    const API_URL = process.env.REACT_APP_ENV;
    const navigate = useNavigate();
    const [error, setError] = useState(''); // State for displaying errors
    const [loading, setLoading] = useState(false); // State for showing loading status

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;
        setFormData(prev => ({ 
            ...prev,
            ...formData, 
            [name]: newValue 
        }));
    };

    const handleBack = (e) => {
        e.preventDefault();
        navigate(
            `/faams-application/${application_id}/${currentStep - 1}`
        );
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Clear previous error
        setError('');
        setLoading(true)
        const essay_data = {
            essay_question1:formData.essay_question1,
            essay_question2:formData.essay_question2,
        }
        try {
            const response = await axiosInstance.patch(
                `${API_URL}/faams-scholarship/${application_id}`, essay_data,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            setFormData(prev => ({
                ...prev,
                ...essay_data
            }));
            navigate(`/faams-application/${application_id}/${currentStep + 1}`);

            console.log("Application Saved");
        } catch (error) {
            console.error("Error saving application:", error);
            alert("Failed to save changes.");
            setLoading(false)
        }

}

    return(
        <div className='faams-application-bg'>
           <div className = 'application-form-box'>
            <form onSubmit={handleSubmit}>
                <div className="faams-app-top-row">
                    <div className='logo-div'>
                        <ArrowLeft className='back-btn' color={"black"} size={40} onClick={handleBack}/>
                        <img src={logo} alt="faams-row-logo" />
                    </div>
                    <h1>FAAMS Scholarship</h1>
                    <p>Essay Questions</p>
                </div>
                <div className="form-group">
                    <label>
                        Describe how your personal background has informed your decision to pursue medicine
                         and how your individual lived experiences will enrich your community.
                    </label>
                    <textarea className='essay-text'
                        name="essay_question1"
                        rows={10}
                        maxLength={5000}
                        value={formData.essay_question1}
                        onChange={handleChange}
                    />
                    <p className='essay-counter'>
                        {formData?.essay_question1?.length}/5000 characters
                    </p>
                </div>
                <div className="form-group">
                    <label>
                        Is there an area of medicine or a particular medical specialty that interests you and why?
                    </label>
                    <textarea className='essay-text'
                        name="essay_question2"
                        rows={10}
                        maxLength={2500}
                        value={formData.essay_question2}
                        onChange={handleChange}
                    />
                    <p className='essay-counter'>
                        {formData?.essay_question2?.length}/2500 characters
                    </p>
                </div>
                <div className='form-group'>
                     {error && <p style={{ color: 'red' }}>{error}</p>} 
                </div>
                <div className='application-form-row'>
                    <div className='button-row'>
                        <button type='submit' disabled={loading}>
                            {loading ? 'Loading...' : 'Continue'}
                        </button>
                    </div>
                </div>
            </form>
           </div>
        </div>
    )
}

function Essay_Questions2({application_id, currentStep, formData, setFormData}){
    const API_URL = process.env.REACT_APP_ENV;
    const navigate = useNavigate();

    const [error, setError] = useState(''); // State for displaying errors
    const [loading, setLoading] = useState(false); // State for showing loading status

   const handleChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;
        setFormData(prev => 
            ({ 
                ...prev,
                ...formData, 
                [name]: newValue 
            }));
    };

    const handleBack = (e) => {
        e.preventDefault();
        navigate(
            `/faams-application/${application_id}/${currentStep - 1}`
        );
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Clear previous error
        setError('');
        setLoading(true)
        const essay_data = {
            essay_question3:formData.essay_question3,
            essay_question4:formData.essay_question4,
        }
        try {
            const response = await axiosInstance.patch(
                `${API_URL}/faams-scholarship/${application_id}`, essay_data,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            setFormData(prev => ({
                ...prev,
                ...essay_data
            }));

            navigate(`/faams-application/${application_id}/${currentStep + 1}`);

            console.log("Application Saved");
        } catch (error) {
            console.error("Error saving application:", error);
            alert("Failed to save changes.");
            setLoading(false)
        }
}

    return(
        <div className='faams-application-bg'>
           <div className = 'application-form-box'>
            <form onSubmit={handleSubmit}>
                <div className="faams-app-top-row">
                    <div className='logo-div'>
                        <ArrowLeft className='back-btn' color={"black"} size={40} onClick={handleBack}/>
                        <img src={logo} alt="faams-row-logo" />
                    </div>
                    <h1>FAAMS Scholarship</h1>
                    <p>Essay Questions</p>
                </div>
                <div className="form-group">
                    <label>
                        Describe the personal accomplishment that makes you most proud. Why is this important to you?
                    </label>
                    <textarea className='essay-text'
                        name="essay_question3"
                        rows={10}
                        maxLength={5000}
                        value={formData.essay_question3}
                        onChange={handleChange}
                    />
                    <p className='essay-counter'>
                        {formData?.essay_question3?.length}/5000 characters
                    </p>
                </div>
                <div className="form-group">
                    <label>
                        Describe what your ideal career will look like in fifteen years.
                    </label>
                    <textarea className='essay-text'
                        name="essay_question4"
                        rows={10}
                        maxLength={2500}
                        value={formData.essay_question4}
                        onChange={handleChange}
                    />
                    <p className='essay-counter'>
                        {formData?.essay_question4?.length}/2500 characters
                    </p>
                </div>
                <div className='form-group'>
                     {error && <p style={{ color: 'red' }}>{error}</p>} 
                </div>
                <div className='application-form-row'>
                    <div className='button-row'>
                        <button type='submit' disabled={loading}>
                            {loading ? 'Loading...' : 'Continue'}
                        </button>
                    </div>
                </div>
            </form>
           </div>
        </div>
    )
}

function PDF({application_id, currentStep, formData, setFormData}) {
    const API_URL = process.env.REACT_APP_ENV;
    const navigate = useNavigate();
    const applicationPdfRef = useRef(null);
    const idPdfRef = useRef(null);

    const [applicationPdf, setApplicationPdf] = useState(null);
    const [photoIdPdf, setPhotoIdPdf] = useState(null);
    const [error, setError] = useState("");
    const [applicationPdfError, setApplicationPdfError] = useState("");
    const [photoIdPdfError, setPhotoIdPdfError] = useState("");
    const [loading, setLoading] = useState(false); // State for showing loading status

    const [reuploadApplicationPdf, setReuploadApplicationPdf] = useState(false);
    const [reuploadPhotoId, setReuploadPhotoId] = useState(false);

    const handleApplicationPdfSelect = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        if (file.type !== "application/pdf") {
            setError("Document must be a PDF.");
            return;
        }

        setApplicationPdf(file);
    };

    const handleBack = (e) => {
        e.preventDefault();
        navigate(
            `/faams-application/${application_id}/${currentStep - 1}`
        );
    }

    const handlePhotoIdSelect = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        if (file.type !== "application/pdf") {
            setError("Photo ID must be a PDF.");
            return;
        }

        setPhotoIdPdf(file);
    };

    const handleContinue = async (e) => {
        e.preventDefault();
        navigate(
                `/faams-application/${application_id}/${currentStep + 1}`
            );
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        if (!reuploadApplicationPdf && !reuploadPhotoId){
            try {
                let hasErrors = false;

                if (!applicationPdf) {
                    setApplicationPdfError("Please upload your application PDF.");
                    hasErrors = true;
                } else {
                    setApplicationPdfError("");
                }

                if (!photoIdPdf) {
                    setPhotoIdPdfError("Please upload your photo ID.");
                    hasErrors = true;
                } else {
                    setPhotoIdPdfError("");
                }

                if (hasErrors) {
                    return;
                }
                const appFormData = new FormData();

                appFormData.append(
                    "file",
                    applicationPdf
                );

                appFormData.append(
                    "application_id",
                    application_id
                );
                const appUpload =
                    await axiosInstance.post(
                        `${API_URL}/faams-scholarship/${application_id}/upload`,
                        appFormData
                    );
                const idFormData = new FormData();

                idFormData.append(
                    "file",
                    photoIdPdf
                );

                idFormData.append(
                    "application_id",
                    application_id
                );

                const idUpload =
                    await axiosInstance.post(
                        `${API_URL}/faams-scholarship/${application_id}/upload`,
                        idFormData
                    );


                const application_pdf_data = {"file_name":applicationPdf.name, "storage_key":appUpload.data.key, "status":"Uploaded","file_type":"Application"}
                const photo_id_pdf_data = {"file_name":photoIdPdf.name, "storage_key":idUpload.data.key, "status":"Uploaded","file_type":"Photo"}
                const pdf_data = {"files":[application_pdf_data, photo_id_pdf_data]}
                const pdf_form_data = {application_pdf_key:appUpload.data.key, photo_id_key:idUpload.data.key}
                await axiosInstance.post(
                    `${API_URL}/faams-scholarship/${application_id}/files`,
                    pdf_data
                );
                setFormData(prev => ({
                    ...prev,
                    ...pdf_form_data
                }));
                navigate(
                    `/faams-application/${application_id}/${currentStep + 1}`
                );
            } catch (err) {
                    console.error("Failed to save PDFs", err);
                    alert("Faled to save changes.")
                    setLoading(false)
                }
        }
        if (reuploadApplicationPdf || reuploadPhotoId){
            if (reuploadApplicationPdf) {
                try 
                {
                    const appFormData = new FormData();

                    appFormData.append(
                        "file",
                        applicationPdf
                    );

                    appFormData.append(
                        "application_id",
                        application_id
                    );

                    const appUpload =
                        await axiosInstance.post(
                            `${API_URL}/faams-scholarship/${application_id}/upload`,
                            appFormData
                        );
                    const application_pdf_data = {"file_name":applicationPdf.name, "storage_key":appUpload.data.key, "status":"Uploaded","file_type":"Application"}
                    const pdf_data = {"files":[application_pdf_data]}
                    const pdf_form_data = {application_pdf_key:appUpload.data.key}

                    await axiosInstance.post(
                        `${API_URL}/faams-scholarship/${application_id}/files`,
                        pdf_data
                    );
                    setFormData(prev => ({
                        ...prev,
                        ...pdf_form_data
                    }));
                }
                catch (err) {
                    console.error("Failed to save Application PDF", err);
                    alert("Faled to save changes.")
                    setLoading(false)
                }
            }

            if (reuploadPhotoId){
                try
                {
                    const idFormData = new FormData();

                    idFormData.append(
                        "file",
                        photoIdPdf
                    );

                    idFormData.append(
                        "application_id",
                        application_id
                    );

                    const idUpload =
                        await axiosInstance.post(
                            `${API_URL}/faams-scholarship/${application_id}/upload`,
                            idFormData
                        );

                    const photo_id_pdf_data = {"file_name":photoIdPdf.name, "storage_key":idUpload.data.key, "status":"Uploaded","file_type":"Photo"}
                    const pdf_data = {"files":[photo_id_pdf_data]}
                    const pdf_form_data = {application_pdf_key:idUpload.data.key}

                    await axiosInstance.post(
                        `${API_URL}/faams-scholarship/${application_id}/files`,
                        pdf_data
                    );
                    setFormData(prev => ({
                        ...prev,
                        ...pdf_form_data
                    }));
                }
                catch (err) {
                    console.error("Failed to save Photo ID", err);
                    alert("Faled to save changes.")
                    setLoading(false)
                }
            }
            navigate(
                    `/faams-application/${application_id}/${currentStep + 1}`
                );

        }
    }

    return (
        <div className="faams-application-bg">
            <div className="pdf-upload-container">
                <div className="faams-app-top-row">
                    <div className='logo-div'>
                        <ArrowLeft className='back-btn' color={"black"} size={40} onClick={handleBack}/>
                        <img src={logo} alt="faams-row-logo" />
                    </div>
                    <h1>FAAMS Scholarship</h1>
                    <p>Upload Your Documents</p>
                </div>
                {(formData?.application_pdf_key && formData?.photo_id_key) ? (
                <>
                            {!reuploadApplicationPdf && (
                                <>
                                <div className="document-row">
                                    <strong>Primary Medical School Application PDF</strong>
                                    <div className="document-actions">
                                        <span className='no-wrap'>
                                            ✓ Uploaded
                                        </span>
                                        <Upload className='upload-button' color={"#2563EB"} size={25} onClick= {() => setReuploadApplicationPdf(true)}/>
                                    </div>
                                </div>
                                </>
                            )}
                            {reuploadApplicationPdf && (
                                <>
                                <div className='pdf-form-group'>
                                    <div className = 'pdf-actions'>
                                        <label>
                                            Please submit a PDF of your approved and processed Primary Medical School Application (AMCAS, AACOMAS, TMDSAS, etc.).
                                        </label>
                                        <input
                                            ref={applicationPdfRef}
                                            type="file"
                                            accept=".pdf"
                                            style={{ display: "none" }}
                                            onChange={handleApplicationPdfSelect}
                                        />
                                        <div
                                            className="upload-box"
                                            onClick={() => applicationPdfRef.current.click()}
                                        >
                                            <FaFilePdf size={48} />
                                            <p>Click to upload your PDF</p>

                                            {applicationPdf && (
                                                <p>{applicationPdf.name}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className='pdf-form-group'>
                                        {applicationPdfError && <p style={{ color: 'red' }}>{applicationPdfError}</p>} 
                                    </div>
                                    <div className='pdf-form-group'>
                                        {error && <p style={{ color: 'red' }}>{error}</p>} 
                                    </div>
                                </div>
                                </>
                            )}
                            {!reuploadPhotoId && (
                            <>
                            <div className="document-row">
                                <strong>Government Photo ID</strong>
                                <div className="document-actions">
                                    <span className='no-wrap'>
                                        ✓ Uploaded
                                    </span>
                                    <Upload className='upload-button' color={"#2563EB"} size={25} onClick={() => setReuploadPhotoId(true)}/>
                                </div>
                            </div>
                            </>
                            )}
                            {reuploadPhotoId && (
                                <>
                                <div className='pdf-form-group'>
                                    <div className='pdf-actions'>
                                        <label>
                                            Please submit a scanned copy of your current government issued photo ID.
                                        </label>
                                        <input
                                            ref={idPdfRef}
                                            type="file"
                                            accept=".pdf"
                                            style={{ display: "none" }}
                                            onChange={handlePhotoIdSelect}
                                        />

                                        <div
                                            className="upload-box"
                                            onClick={() => idPdfRef.current.click()}
                                        >
                                            <FaFilePdf size={48} />
                                            <p>Click to upload your PDF</p>

                                            {photoIdPdf && (
                                                <p>{photoIdPdf.name}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className='pdf-form-group'>
                                        {photoIdPdfError && <p style={{ color: 'red' }}>{photoIdPdfError}</p>} 
                                    </div>
                                    <div className='pdf-form-group'>
                                        {error && <p style={{ color: 'red' }}>{error}</p>} 
                                    </div>
                                </div>
                                </>
                            )}
                            {(reuploadApplicationPdf || reuploadPhotoId)?(
                                <div className='application-form-row'>
                                    <div className='button-row'>
                                        <button type='submit' onClick={handleSubmit} disabled={loading}>
                                            {loading ? 'Loading...' : 'Continue'}
                                        </button>
                                    </div>
                                </div>
                            ):(
                                <div className='application-form-row'>
                                    <div className='button-row'>
                                        <button type='submit' onClick={handleContinue} disabled={loading}>
                                            {loading ? 'Loading...' : 'Continue'}
                                        </button>
                                    </div>
                                </div>
                            )}
                </>
                ):(
                <>
                <div className='pdf-form-group'>
                    <label>
                        Please submit a PDF of your approved and processed Primary Medical School Application (AMCAS, AACOMAS, TMDSAS, etc.).
                    </label>
                    <input
                        ref={applicationPdfRef}
                        type="file"
                        accept=".pdf"
                        style={{ display: "none" }}
                        onChange={handleApplicationPdfSelect}
                    />
                    <div
                        className="upload-box"
                        onClick={() => applicationPdfRef.current.click()}
                    >
                        <FaFilePdf size={48} />
                        <p>Click to upload your PDF</p>

                        {applicationPdf && (
                            <p>{applicationPdf.name}</p>
                        )}
                    </div>
                    <div className='pdf-form-group'>
                        {applicationPdfError && <p style={{ color: 'red' }}>{applicationPdfError}</p>} 
                    </div>
                    <div className='pdf-form-group'>
                        {error && <p style={{ color: 'red' }}>{error}</p>} 
                    </div>
                </div>
                <div className='pdf-form-group'>
                    <label>
                        Please submit a scanned copy of your current government issued photo ID.
                    </label>
                    <input
                        ref={idPdfRef}
                        type="file"
                        accept=".pdf"
                        style={{ display: "none" }}
                        onChange={handlePhotoIdSelect}
                    />

                    <div
                        className="upload-box"
                        onClick={() => idPdfRef.current.click()}
                    >
                        <FaFilePdf size={48} />
                        <p>Click to upload your PDF</p>

                        {photoIdPdf && (
                            <p>{photoIdPdf.name}</p>
                        )}
                    </div>
                    <div className='pdf-form-group'>
                        {photoIdPdfError && <p style={{ color: 'red' }}>{photoIdPdfError}</p>} 
                    </div>
                    <div className='pdf-form-group'>
                        {error && <p style={{ color: 'red' }}>{error}</p>} 
                    </div>
                </div>
                <div className='application-form-row'>
                    <div className='button-row'>
                        <button type='submit' onClick={handleSubmit} disabled={loading}>
                            {loading ? 'Loading...' : 'Continue'}
                        </button>
                    </div>
                </div>
                </>
                )}
            </div>
        </div>
    );
}
function LOR({currentStep, application_id, formData, setFormData}) {
    const API_URL = process.env.REACT_APP_ENV;
    const navigate = useNavigate();
    const [error, setError] = useState(''); // State for displaying errors
    const [loading, setLoading] = useState(false); // State for showing loading status

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;
        setFormData(prev => 
            ({ 
                ...prev,
                ...formData, 
                [name]: newValue 
            }));
    };

    const handleBack = (e) => {
        e.preventDefault();
        navigate(
            `/faams-application/${application_id}/${currentStep - 1}`
        );
    }

     const handleSubmit = async (e) => {
        e.preventDefault();

        // Clear previous error
        setError('');

        setLoading(true);
        // Prepare the data to send to the backend
        const recommendationData = {
            recommenders: [
                {
                    first_name:formData.recommender_1_first_name,
                    last_name:formData.recommender_1_last_name,
                    email_address:formData.recommender_1_email
                },
                {
                    first_name:formData.recommender_2_first_name,
                    last_name:formData.recommender_2_last_name,
                    email_address:formData.recommender_2_email
                },
                {
                    first_name:formData.recommender_3_first_name,
                    last_name:formData.recommender_3_last_name,
                    email_address:formData.recommender_3_email
                }
            ]
        };
        try {
            const response = await axiosInstance.post(
                `${API_URL}/faams-scholarship/${application_id}/recommendation`, recommendationData,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            setFormData(prev => ({
                ...prev,
                ...recommendationData
            }));
            navigate(`/faams-application/${application_id}/${currentStep += 1}`);

            console.log("Application Saved");
        } catch (error) {
            console.error("Error saving application:", error);
            alert("Failed to save changes.");
            setLoading(false)
        }
    }

    return (
        <div className='faams-application-bg'>
           <div className = 'application-form-box'>
                <form onSubmit={handleSubmit}>
                <div className="faams-app-top-row">
                    <div className='logo-div'>
                        <ArrowLeft className='back-btn' color={"black"} size={40} onClick={handleBack}/>
                        <img src={logo} alt="faams-row-logo" />
                    </div>
                    <h1>FAAMS Scholarship</h1>
                    <p>Letters of Recommendation</p>
                </div>
                <div className='lor-reqs'>
                    <p>Please acquire three letters of recommendation from persons who can attest to the applicant's 
                        accomplishments, work ethic, character, and goals. Letters can be from faculty members who have
                        taught the applicant or supervisors; all three cannot be from the same categorical source 
                        (i.e., two letters from faculty members and one letter from a supervisor is acceptable)</p>
                </div>
                    <div className='application-form-row'>
                        <div className='form-group'>
                            <label for="recommender_1_first_name">Recommender #1</label>
                            <div className='recommender-row'>
                                <input 
                                    type="text"
                                    name="recommender_1_first_name"
                                    placeholder="First Name"
                                    value={formData.recommender_1_first_name}
                                    onChange={handleChange}
                                    required
                                />
                                <input 
                                    type="text"
                                    name="recommender_1_last_name"
                                    placeholder="Last Name"
                                    value={formData.recommender_1_last_name}
                                    onChange={handleChange}
                                    required
                                />
                                <input 
                                    type="text"
                                    name="recommender_1_email"
                                    placeholder="Email Address"
                                    value={formData.recommender_1_email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    <div className='application-form-row'>
                        <div className='form-group'>
                            <label for="recommender_2_first_name">Recommender #2</label>
                            <div className='recommender-row'>
                                <input 
                                    type="text"
                                    name="recommender_2_first_name"
                                    placeholder="First Name"
                                    value={formData.recommender_2_first_name}
                                    onChange={handleChange}
                                    required
                                />
                                <input 
                                    type="text"
                                    name="recommender_2_last_name"
                                    placeholder="Last Name"
                                    value={formData.recommender_2_last_name}
                                    onChange={handleChange}
                                    required
                                />
                                <input 
                                    type="text"
                                    name="recommender_2_email"
                                    placeholder="Email Address"
                                    value={formData.recommender_2_email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    <div className='application-form-row'>
                        <div className='form-group'>
                            <label for="recommender_3_first_name">Recommender #3</label>
                            <div className='recommender-row'>
                                <input 
                                    type="text"
                                    name="recommender_3_first_name"
                                    placeholder="First Name"
                                    value={formData.recommender_3_first_name}
                                    onChange={handleChange}
                                    required
                                />
                                <input 
                                    type="text"
                                    name="recommender_3_last_name"
                                    placeholder="Last Name"
                                    value={formData.recommender_3_last_name}
                                    onChange={handleChange}
                                    required
                                />
                                <input 
                                    type="text"
                                    name="recommender_3_email"
                                    placeholder="Email Address"
                                    value={formData.recommender_3_email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    <div className='application-form-row'>
                     {error && <p style={{ color: 'red' }}>{error}</p>} 
                    </div>
                    <div className='application-form-row'>
                        <div className='button-row'>
                            <button type='submit' disabled={loading}>
                                {loading ? 'Loading...' : 'Continue'}
                            </button>
                        </div>
                    </div>
                </form>
           </div>
        </div>
    )
};

function Misc({application_id, currentStep, formData, setFormData, existingMiscFiles, setExistingMiscFiles}) {
    const API_URL = process.env.REACT_APP_ENV;
    const navigate = useNavigate();
    const miscFileRef = useRef(null);

    const [miscFiles, setMiscFiles] = useState([]);
    const [miscReplacements, setMiscReplacements] = useState({});
    const [reuploadMisc, setReuploadMisc] = useState({});
    const [removedMiscFiles, setRemovedMiscFiles] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const file_type = "Misc";

    const fileAllowList = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "image/png",
        "image/jpeg",
        "text/plain"
    ];

    // --------------------------------------------------
    // Handle selecting a new file OR replacement file
    // --------------------------------------------------
    const handleMiscFileSelect = (e) => {
        const files = Array.from(e.target.files);

        if (!files.length) return;

        const replacementIndex =
            miscFileRef.current.dataset.index;

        // ----------------------------------------------
        // REPLACEMENT
        // ----------------------------------------------
        if (replacementIndex !== undefined) {
            const index = Number(replacementIndex);
            const originalFile = existingMiscFiles[index];

            if (!originalFile) {
                console.error("Could not find original file.");
                return;
            }

            // Store the new browser File
            setMiscReplacements(prev => ({
                ...prev,
                [index]: files[0]
            }));

            // Mark the ORIGINAL DB file for removal
            setRemovedMiscFiles(prev => {
                if (
                    prev.some(
                        file =>
                            file.file_id ===
                            originalFile.file_id
                    )
                ) {
                    return prev;
                }

                return [
                    ...prev,
                    {
                        file_id: originalFile.file_id,
                        file_name: originalFile.file_name
                    }
                ];
            });

            // KEEP the row in reupload mode
            // so the new file shows with Upload + X
            setReuploadMisc(prev => ({
                ...prev,
                [index]: true
            }));

            delete miscFileRef.current.dataset.index;
        }

        // ----------------------------------------------
        // NORMAL NEW UPLOAD
        // ----------------------------------------------
        else {
            setMiscFiles(prev => [
                ...prev,
                ...files
            ]);
        }

        // Allows selecting the same file again
        e.target.value = "";
    };

    // --------------------------------------------------
    // Remove a NEW file that hasn't been uploaded yet
    // --------------------------------------------------
    const removeFile = (index) => {
        setMiscFiles(prev =>
            prev.filter((_, i) => i !== index)
        );
    };

    // --------------------------------------------------
    // Remove an EXISTING DB file
    // --------------------------------------------------
    const removeExistingFile = (file) => {
        setRemovedMiscFiles(prev => {
            if (
                prev.some(
                    removed =>
                        removed.file_id === file.file_id
                )
            ) {
                return prev;
            }

            return [
                ...prev,
                {
                    file_id: file.file_id,
                    file_name: file.file_name
                }
            ];
        });

        // If the user deletes the original file,
        // make sure any replacement state is removed.
        const index = existingMiscFiles.findIndex(
            existing =>
                existing.file_id === file.file_id
        );

        if (index !== -1) {
            setMiscReplacements(prev => {
                const updated = { ...prev };
                delete updated[index];
                return updated;
            });

            setReuploadMisc(prev => {
                const updated = { ...prev };
                delete updated[index];
                return updated;
            });
        }
    };

    // --------------------------------------------------
    // Cancel a replacement
    // --------------------------------------------------
    const cancelReplacement = (index) => {
        const originalFile = existingMiscFiles[index];

        // Remove replacement File
        setMiscReplacements(prev => {
            const updated = { ...prev };
            delete updated[index];
            return updated;
        });

        // Remove original file from removal list
        if (originalFile) {
            setRemovedMiscFiles(prev =>
                prev.filter(
                    file =>
                        file.file_id !==
                        originalFile.file_id
                )
            );
        }

        // Exit reupload mode
        setReuploadMisc(prev => ({
            ...prev,
            [index]: false
        }));

        delete miscFileRef.current.dataset.index;
    };

    // --------------------------------------------------
    // Open file picker for a REPLACEMENT
    // --------------------------------------------------
    const openReplacementPicker = (index) => {
        miscFileRef.current.dataset.index = index;
        miscFileRef.current.click();
    };

    // --------------------------------------------------
    // Open file picker for a NEW file
    // --------------------------------------------------
    const openNewFilePicker = () => {
        delete miscFileRef.current.dataset.index;
        miscFileRef.current.click();
    };

    // --------------------------------------------------
    // Back button
    // --------------------------------------------------
    const handleBack = (e) => {
        e.preventDefault();

        navigate(
            `/faams-application/${application_id}/${currentStep - 1}`
        );
    };

    // --------------------------------------------------
    // Submit / Continue
    // --------------------------------------------------
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            // ------------------------------------------
            // 1. Remove deleted/replaced existing files
            // ------------------------------------------
            if (removedMiscFiles.length > 0) {
                await axiosInstance.post(
                    `${API_URL}/faams-scholarship/${application_id}/misc-remove/${file_type}`,
                    removedMiscFiles
                );
            }

            // ------------------------------------------
            // 2. Collect ONLY new/replacement Files
            //
            // Existing DB files are NOT uploaded again.
            // ------------------------------------------
            const filesToUpload = [
                ...miscFiles,
                ...Object.values(miscReplacements)
            ];

            let uploadedStorageKeys = [];

            // ------------------------------------------
            // 3. Upload new/replacement files
            // ------------------------------------------
            if (filesToUpload.length > 0) {
                const miscFormData = new FormData();

                filesToUpload.forEach(file => {
                    miscFormData.append("files", file);
                });

                miscFormData.append(
                    "application_id",
                    application_id
                );

                const appUpload =
                    await axiosInstance.post(
                        `${API_URL}/faams-scholarship/${application_id}/misc-upload`,
                        miscFormData
                    );

                uploadedStorageKeys = appUpload.data;
            }

            // ------------------------------------------
            // 4. Create DB rows for uploaded files
            // ------------------------------------------
            if (uploadedStorageKeys.length > 0) {
                const miscPdfData =
                    filesToUpload.map(
                        (file, index) => ({
                            file_name: file.name,
                            storage_key:
                                uploadedStorageKeys[index],
                            status: "Uploaded",
                            file_type: "Misc"
                        })
                    );

                const existingMiscFilesResponse =
                    await axiosInstance.post(
                        `${API_URL}/faams-scholarship/${application_id}/files`,
                        {
                            files: miscPdfData
                        }
                    );
            }

            // ------------------------------------------
            // 5. Get the current files from DB
            // ------------------------------------------
            const updatedFilesResponse =
                await axiosInstance.get(
                    `${API_URL}/faams-scholarship/${application_id}/retrieve-files/${file_type}`
                );

            const updatedFiles =
                updatedFilesResponse.data;

            // ------------------------------------------
            // 6. Update React state
            // ------------------------------------------
            setExistingMiscFiles(updatedFiles);

            const file_names = updatedFiles.map(file => file.file_name);

            setFormData(prev => ({
                ...prev,
                misc_file_key: file_names
            }));

            // ------------------------------------------
            // 7. Continue
            // ------------------------------------------
            navigate(
                `/faams-application/${application_id}/${currentStep + 1}`
            );

        } catch (err) {
            console.error(
                "Failed to save miscellaneous files:",
                err
            );

            setError("Failed to save changes.");
            alert("Failed to save changes.");

            setLoading(false);
        }
    };

    // --------------------------------------------------
    // Files that have NOT been permanently deleted
    //
    // IMPORTANT:
    // A file with a replacement is still displayed.
    // --------------------------------------------------
    const visibleExistingFiles =
        existingMiscFiles?.filter(file => {
            const index = existingMiscFiles.findIndex(
                existing =>
                    existing.file_id === file.file_id
            );

            const hasReplacement =
                miscReplacements[index] !== undefined;

            const isRemoved =
                removedMiscFiles.some(
                    removed =>
                        removed.file_id === file.file_id
                );

            // Show it if it has a replacement.
            // Otherwise hide it if it was deleted.
            return isRemoved
                ? hasReplacement
                : true;
        }) || [];

    return (
        <div className="faams-application-bg">
            <div className="pdf-upload-container">

                {/* ==========================================
                    HEADER
                ========================================== */}

                <div className="faams-app-top-row">
                    <div className="logo-div">

                        <ArrowLeft
                            className="back-btn"
                            color="black"
                            size={40}
                            onClick={handleBack}
                        />

                        <img
                            src={logo}
                            alt="faams-row-logo"
                        />

                    </div>

                    <h1>FAAMS Scholarship</h1>

                    <p>Miscellaneous Files</p>
                </div>


                {/* ==========================================
                    EXISTING FILES
                ========================================== */}

                {visibleExistingFiles.length > 0 ? (
                    <div className="pdf-form-group">

                        {existingMiscFiles.map(
                            (file, index) => {

                                const replacement =
                                    miscReplacements[index];

                                const isRemoved =
                                    removedMiscFiles.some(
                                        removed =>
                                            removed.file_id ===
                                            file.file_id
                                    );

                                /*
                                 * If the file was removed AND
                                 * there is no replacement,
                                 * don't display it.
                                 */
                                if (
                                    isRemoved &&
                                    !replacement
                                ) {
                                    return null;
                                }

                                /*
                                 * Show replacement name if
                                 * one exists, otherwise show
                                 * original DB filename.
                                 */
                                const displayFile =
                                    replacement
                                        ? replacement.name
                                        : file.file_name;

                                return (
                                    <div
                                        className="misc-file-row"
                                        key={file.file_id}
                                    >

                                        <strong>
                                            {displayFile}
                                        </strong>


                                        {/* ==================================
                                            NORMAL EXISTING FILE
                                        ================================== */}

                                        {!reuploadMisc[index] ? (

                                            <div className="misc-file-actions">

                                                <span className="no-wrap">
                                                    ✓ Uploaded
                                                </span>

                                                <Upload
                                                    className="upload-button"
                                                    color="#2563EB"
                                                    size={25}
                                                    onClick={() => {
                                                        setReuploadMisc(
                                                            prev => ({
                                                                ...prev,
                                                                [index]: true
                                                            })
                                                        );
                                                    }}
                                                />

                                                <Trash2
                                                    className="trash-button"
                                                    color="red"
                                                    size={25}
                                                    onClick={() =>
                                                        removeExistingFile(
                                                            file
                                                        )
                                                    }
                                                />

                                            </div>

                                        ) : (

                                            /* ==================================
                                                REUPLOAD MODE

                                                This now stays visible after
                                                selecting the replacement.
                                            ================================== */

                                            <div className="reupload-action">

                                                <div
                                                    className="upload-box small"
                                                    onClick={() =>
                                                        openReplacementPicker(
                                                            index
                                                        )
                                                    }
                                                >

                                                    <Upload
                                                        color="#2563EB"
                                                        size={28}
                                                    />

                                                    <p>
                                                        Replace File
                                                    </p>

                                                </div>


                                                <X
                                                    className="collapse-reupload"
                                                    color="red"
                                                    size={25}
                                                    onClick={() =>
                                                        cancelReplacement(
                                                            index
                                                        )
                                                    }
                                                />

                                            </div>
                                        )}

                                    </div>
                                );
                            }
                        )}


                        {/* ==========================================
                            PLUS BUTTON — ADD MORE FILES
                        ========================================== */}

                        <div
                            className="misc-add-file"
                            onClick={openNewFilePicker}
                            style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                marginTop: "15px"
                            }}
                        >

                            <Plus
                                color="#2563EB"
                                size={25}
                            />

                            <span>
                                Add Another File
                            </span>

                        </div>


                        {/* ==========================================
                            NEW FILES SELECTED THIS SESSION
                        ========================================== */}

                        {miscFiles.length > 0 && (
                            <div
                                className="pdf-form-group"
                                style={{
                                    marginTop: "15px"
                                }}
                            >

                                {miscFiles.map(
                                    (file, index) => (
                                        <div
                                            className="misc-file-actions-upload"
                                            key={index}
                                        >

                                            <span>
                                                {file.name}
                                            </span>

                                            <Trash2
                                                className="trash-button"
                                                color="red"
                                                size={20}
                                                onClick={() =>
                                                    removeFile(
                                                        index
                                                    )
                                                }
                                            />

                                        </div>
                                    )
                                )}

                            </div>
                        )}

                    </div>

                ) : (

                    /* ==========================================
                       NO EXISTING FILES
                    ========================================== */

                    <div className="pdf-form-group">

                        <label>
                            Optionally, please submit any
                            miscellaneous documents that support
                            your application.
                        </label>

                        <div
                            className="upload-box"
                            onClick={openNewFilePicker}
                        >

                            <FaFilePdf size={48} />

                            <p>
                                Click To Upload Any
                                Miscellaneous Documents
                            </p>

                            {miscFiles.map(
                                (file, index) => (
                                    <div
                                        className="misc-file-actions-upload"
                                        key={index}
                                        onClick={e =>
                                            e.stopPropagation()
                                        }
                                    >

                                        <span>
                                            {file.name}
                                        </span>

                                        <Trash2
                                            className="trash-button"
                                            color="red"
                                            size={20}
                                            onClick={() =>
                                                removeFile(
                                                    index
                                                )
                                            }
                                        />

                                    </div>
                                )
                            )}

                        </div>

                    </div>
                )}


                {/* ==========================================
                    ERROR
                ========================================== */}

                <div className="pdf-form-group">

                    {error && (
                        <p
                            style={{
                                color: "red"
                            }}
                        >
                            {error}
                        </p>
                    )}

                </div>


                {/* ==========================================
                    HIDDEN FILE INPUT
                ========================================== */}

                <input
                    ref={miscFileRef}
                    type="file"
                    multiple
                    accept=".pdf,.doc,.docx,.txt,.png,.jpg,.jpeg"
                    style={{
                        display: "none"
                    }}
                    onChange={handleMiscFileSelect}
                />


                {/* ==========================================
                    CONTINUE BUTTON
                ========================================== */}

                <div className="application-form-row">

                    <div className="button-row">

                        <button
                            type="submit"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading
                                ? "Loading..."
                                : "Continue"}
                        </button>

                    </div>

                </div>

            </div>
        </div>
    );
}



function ReviewSubmit({application_id, formData, setFormData}){
    const API_URL = process.env.REACT_APP_ENV;
    const navigate = useNavigate();
    const [error, setError] = useState(''); // State for displaying errors
    const [loading, setLoading] = useState(false); // State for showing loading status
    const recommenders = [
        {
            first_name: formData.recommender_1_first_name,
            last_name: formData.recommender_1_last_name,
            email_address: formData.recommender_1_email,
        },
        {
            first_name: formData.recommender_2_first_name,
            last_name: formData.recommender_2_last_name,
            email_address: formData.recommender_2_email,
        },
        {
            first_name: formData.recommender_3_first_name,
            last_name: formData.recommender_3_last_name,
            email_address: formData.recommender_3_email,
        },
    ].filter(r => r.first_name || r.last_name || r.email_address);

    const handleEdit = (step) => {
        navigate(`/faams-application/${application_id}/${step}`);
    }
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Clear previous error
        setError('');

        setLoading(true);
        // Prepare the data to send to the backend
        const statusData = {
            status:"Submitted"
        };
        const pdf_data = {
            application_pdf_key:formData.application_pdf_key,
            photo_id_key:formData.photo_id_key,
            misc_file_key:formData.misc_file_key
        }
        try {
            const response = await axiosInstance.patch(
                `${API_URL}/faams-scholarship/${application_id}`, pdf_data,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            console.log("Application Updated");
        } catch (error) {
            console.error("Error updating application:", error);
            alert("Failed to save changes.");
            setLoading(false)
            throw(error)
        }

        try {
            const response = await axiosInstance.post(
                `${API_URL}/faams-scholarship/${application_id}/submit`, statusData,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            navigate("/application-confirmation", {
                state: {
                    faamsApp: true,
                },
            });

            console.log("Application Saved");
        } catch (error) {
            console.error("Error saving application:", error);
            alert("Failed to save changes.");
            setLoading(false)
            throw(error)
        }
    }

    return(
        <div className='faams-application-bg'>
           <div className = 'application-form-box'>
                <div className="faams-app-top-row">
                    <img src={logo} alt="faams-row-logo" />
                    <h1>FAAMS Scholarship</h1>
                    <p>Personal Information</p>
                </div>
                <div className="review-container">
                    {/* Personal Information */}
                    <div className="review-card">
                        <div className="card-header">
                            <h2>Personal Information</h2>

                            <button
                                className="edit-button"
                                onClick={() => handleEdit(1)}
                            >
                                Edit
                            </button>
                        </div>

                        <div className="review-grid">
                            <div>
                                <strong>Name</strong>
                                <p>
                                    {formData?.firstName}{" "}
                                    {formData?.lastName}
                                </p>
                            </div>

                            <div>
                                <strong>Email</strong>
                                <p>{formData?.email}</p>
                            </div>

                            <div>
                                <strong>Phone</strong>
                                <p>{formData?.phone}</p>
                            </div>

                            <div>
                                <strong>Address</strong>
                                <p>
                                    {formData?.address}
                                    {formData?.address2 &&
                                        `, ${formData?.address2}`}
                                </p>
                            </div>

                            <div>
                                <strong>City</strong>
                                <p>{formData?.city}</p>
                            </div>

                            <div>
                                <strong>State</strong>
                                <p>{formData?.state}</p>
                            </div>

                            <div>
                                <strong>Zip Code</strong>
                                <p>{formData?.zip}</p>
                            </div>

                            <div>
                                <strong>Graduation Year</strong>
                                <p>{formData?.gradYear}</p>
                            </div>

                            <div>
                                <strong>Gender</strong>
                                <p>{formData?.gender}</p>
                            </div>

                            <div>
                                <strong>Race</strong>
                                <p>{formData?.race}</p>
                            </div>
                            <div>
                                <strong>Hispanic Origin</strong>
                                <p>{formData?.ethnicity}</p>
                            </div>
                        </div>
                    </div>

                    {/* Essays 1 & 2 */}
                    <div className="review-card">
                        <div className="card-header">
                            <h2>Essay Responses (1-2)</h2>

                            <button
                                className="edit-button"
                                onClick={() => handleEdit(2)}
                            >
                                Edit
                            </button>
                        </div>

                        <div className="essay-preview-card">
                            <h4>Describe how your personal background has informed your decision to pursue medicine
                         and how your individual lived experiences will enrich your community.</h4>

                            <p>
                                {formData?.essay_question1?.slice(
                                    0,
                                    250
                                )}
                                {formData?.essay_question1?.length >
                                    250 && "..."}
                            </p>

                            <small>
                                {
                                    formData?.essay_question1
                                        ?.split(" ")
                                        .length
                                }{" "}
                                words
                            </small>
                        </div>

                        <div className="essay-preview-card">
                            <h4>Is there an area of medicine or a particular medical specialty that interests you and why?</h4>

                            <p>
                                {formData?.essay_question2?.slice(
                                    0,
                                    250
                                )}
                                {formData?.essay_question2?.length >
                                    250 && "..."}
                            </p>

                            <small>
                                {
                                    formData?.essay_question2
                                        ?.split(" ")
                                        .length
                                }{" "}
                                words
                            </small>
                        </div>
                    </div>

                    {/* Essays 3 & 4 */}
                    <div className="review-card">
                        <div className="card-header">
                            <h2>Essay Responses (3-4)</h2>

                            <button
                                className="edit-button"
                                onClick={() => handleEdit(3)}
                            >
                                Edit
                            </button>
                        </div>

                        <div className="essay-preview-card">
                            <h4>Describe the personal accomplishment that makes you most proud. Why is this important to you?</h4>

                            <p>
                                {formData?.essay_question3?.slice(
                                    0,
                                    250
                                )}
                                {formData?.essay_question3?.length >
                                    250 && "..."}
                            </p>

                            <small>
                                {
                                    formData?.essay_question3
                                        ?.split(" ")
                                        .length
                                }{" "}
                                words
                            </small>
                        </div>

                        <div className="essay-preview-card">
                            <h4>Describe what your ideal career will look like in fifteen years.</h4>

                            <p>
                                {formData?.essay_question4?.slice(
                                    0,
                                    250
                                )}
                                {formData?.essay_question4?.length >
                                    250 && "..."}
                            </p>

                            <small>
                                {
                                    formData?.essay_question4
                                        ?.split(" ")
                                        .length
                                }{" "}
                                words
                            </small>
                        </div>
                    </div>

                    {/* Documents */}
                    <div className="review-card">
                        <div className="card-header">
                            <h2>Uploaded Documents</h2>

                            <button
                                className="edit-button"
                                onClick={() => handleEdit(4)}
                            >
                                Edit
                            </button>
                        </div>

                        <div className="document-row">
                            <strong>Primary Medical School Application PDF</strong>

                            <span>
                                {formData?.application_pdf_key
                                    ? "✓ Uploaded"
                                    : "Missing"}
                            </span>
                        </div>

                        <div className="document-row">
                            <strong>Government Photo ID</strong>

                            <span>
                                {formData?.photo_id_key
                                    ? "✓ Uploaded"
                                    : "Missing"}
                            </span>
                        </div>
                    </div>

                    {/* Recommenders */}
                    <div className="review-card">
                        <div className="card-header">
                            <h2>Letters of Recommendation</h2>

                            <button
                                className="edit-button"
                                onClick={() => handleEdit(5)}
                            >
                                Edit
                            </button>
                        </div>

                        {recommenders?.map(
                            (recommendation, index) => (
                                <div
                                    key={
                                        recommendation.id ||
                                        index
                                    }
                                    className="recommender-card"
                                >
                                    <h4>
                                        Recommender {index + 1}
                                    </h4>
                                    <div className='name-row'>
                                        <p className='name-tag'>Name:</p>
                                        <p>
                                            {recommendation.first_name}{" "}
                                            {recommendation.last_name}
                                        </p>
                                    </div>

                                    <div className='email-row'>
                                        <p className='email-tag'>Email Address:</p>
                                        <p>
                                            {recommendation.email_address}
                                        </p>
                                    </div>

                                </div>
                            )
                        )}
                    </div>
                    <div className='review-card'>
                        <div className="card-header">
                            <h2>Miscellaneous Documents</h2>

                            <button
                                className="edit-button"
                                onClick={() => handleEdit(6)}
                            >
                                Edit
                            </button>
                        </div>

                        <div className="document-row">
                            <strong>Miscellaneous Documents</strong>

                            <span>
                                {formData?.misc_file_key?.length > 0
                                    ? "✓ Uploaded"
                                    : "Missing"}
                            </span>
                        </div>
                    </div>

                    {/* Final Submit */}
                    <div className="submit-section">
                        <div className="submission-notice">
                            By submitting, you certify that all
                            information provided is accurate and
                            complete.
                        </div>
                        <div className='button-row'>
                            <button type='submit' onClick={handleSubmit} disabled={loading}>
                                {loading ? 'Loading...' : 'Submit Application'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

};

export default Faams_Application;